// extracted by mini-css-extract-plugin
export default {"listContainer":"List_listContainer__FLbHU","cardContainer":"List_cardContainer__EKB3D","cardInteractions":"List_cardInteractions__O7SaL"};